import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/shared/services/apiConfig';
import type { OrganizationOverviewData } from '@/shared/types/overviewTypes';
import { PaginatedResponse, SingleResponse } from '@/shared/types/responseTypes';

// Single-account overview: wire returns `data.results` with exactly one `{ organizationId, name, summary }`.
export const useOrganizationOverview = () => {
  return useQuery({
    queryKey: ['organization-overview'],
    queryFn: async () => {
      const response = await apiClient.get<SingleResponse<OrganizationOverviewData>>(
        `/api/v1/overview`
      );
      return response?.data;
    },
  });
};

// Global account overview: wire returns `data.results` with all accounts.
export const useGlobalOrganizationOverview = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      return apiClient.get<PaginatedResponse<OrganizationOverviewData>>(
        `/api/v1/global-overview`
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['global-overview'] });
    },
    onError: (error: Error) => {
      return error;
    },
  });
};